import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    overflow: 'scroll',
    alignItems: 'center',
    gap: theme.spacing(1),
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
  },
  tabContainer: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'center',
    scrollSnapType: 'x mandatory',
    padding: theme.spacing(1.5, 1),
    '-webkit-overflow-scrolling': 'touch',
    '& > p': {
      fontSize: theme.typography.pxToRem(18),
    },
    '& > .material-icons': {
      fontSize: theme.typography.pxToRem(20),
    },
    '&[data-active="false"]': {
      '& > p, & > .material-icons': {
        color: theme.palette.fidelity.tabColor,
      },
      borderBottom: `3px solid ${theme.palette.fidelity.tabColor}`,
    },
    '&[data-active="true"]': {
      '& > p, & > .material-icons': {
        fontWeight: 500,
        color: theme.palette.fidelity.tabColorActivity,
      },
      borderBottom: `3px solid ${theme.palette.fidelity.tabColorActivity}`,
    },
  },
}))
